module.exports = __webpack_public_path__ + "static/media/FellowshipGroups.caaee08f.png";